import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper, 
  Container 
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleLogin = () => {
    if (code === 'MHEM') {
      onLogin();
      localStorage.setItem('isLoggedIn', 'true');
    } else {
      setError(true);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <Container maxWidth="sm">
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh'
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '100%',
            maxWidth: 400,
          }}
        >
          <Box 
            component="img"
            src="/logo.png"
            alt="MHEM AI Logo"
            sx={{ width: 100, height: 100, mb: 2 }}
          />
          <Typography component="h1" variant="h5" gutterBottom>
            {t('login.title')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {t('login.prompt')}
          </Typography>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            type="password"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError(false);
            }}
            onKeyPress={handleKeyPress}
            error={error}
            helperText={error ? t('login.error') : ''}
            sx={{ mb: 2 }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleLogin}
            sx={{ mt: 2 }}
          >
            {t('login.button')}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
